import React from 'react';

const fmtBRL = (v) => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(Number(v) || 0);
const fmtNum = (v) => Number(v || 0).toLocaleString('pt-BR', { maximumFractionDigits: 2 });

const DEZENA_LABEL = ['1ª dezena', '2ª dezena', '3ª dezena'];

// Card da unidade no formato da planilha (B25:F34)
export default function ClinicFunnelUnitCard({ row, referenceMonth, onClick, compact = false }) {
  if (!row) return null;
  const refLabel = referenceMonth
    ? new Date(referenceMonth).toLocaleDateString('pt-BR', { month: 'long', year: 'numeric', timeZone: 'UTC' })
    : '—';
  const dezenas = row.card.dezenas;
  const totalValor = dezenas.reduce((a, d) => a + d.valor, 0);
  const totalDias = dezenas.reduce((a, d) => a + d.dias, 0);
  const totalMeta = dezenas.reduce((a, d) => a + d.meta, 0);
  const totalBig = dezenas.reduce((a, d) => a + d.big, 0);
  const Wrapper = onClick ? 'button' : 'div';

  return (
    <Wrapper
      type={onClick ? 'button' : undefined}
      onClick={onClick}
      className={`text-left bg-white rounded-2xl border border-slate-100 shadow-sm overflow-hidden w-full ${onClick ? 'hover:border-primary/40 hover:shadow-md transition-all cursor-pointer' : ''}`}
    >
      <div className="px-4 py-3 bg-slate-50 border-b border-slate-100">
        <h4 className="font-headline font-bold text-slate-800 text-sm leading-tight">{row.name}</h4>
      </div>
      <dl className={`px-4 py-3 grid gap-y-1.5 text-sm ${compact ? '' : 'sm:grid-cols-2 sm:gap-x-6'}`}>
        <div className="flex justify-between gap-3"><dt className="text-slate-500">Mês de referência</dt><dd className="font-semibold text-slate-800 capitalize">{refLabel}</dd></div>
        <div className="flex justify-between gap-3"><dt className="text-slate-500">Valor da meta</dt><dd className="font-bold text-slate-800">{fmtBRL(row.meta)}</dd></div>
        <div className="flex justify-between gap-3"><dt className="text-slate-500">Comparecimento CRC</dt><dd className="font-semibold text-slate-800">{fmtNum(row.comparecimentos)}</dd></div>
        <div className="flex justify-between gap-3">
          <dt className="text-slate-500">Comparecimento Recepção</dt>
          <dd className="font-semibold text-slate-800">{row.recepcao ? fmtNum(row.recepcao.comparecimentos) : '—'}</dd>
        </div>
      </dl>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="bg-slate-50 text-[10px] font-bold uppercase text-slate-500">
              <th className="px-4 py-2 text-left">Metas CRC</th>
              <th className="px-2 py-2 text-right">Dias úteis</th>
              <th className="px-2 py-2 text-right">Meta</th>
              <th className="px-2 py-2 text-right">Big (×125%)</th>
              <th className="px-4 py-2 text-right whitespace-nowrap">Com. / Aval.</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100 tabular-nums">
            {dezenas.map((d, i) => (
              <tr key={i}>
                <td className="px-4 py-2 font-medium text-slate-700 whitespace-nowrap">{DEZENA_LABEL[i]}</td>
                <td className="px-2 py-2 text-right text-slate-600">{d.dias}</td>
                <td className="px-2 py-2 text-right text-slate-800">{fmtNum(d.meta)}</td>
                <td className="px-2 py-2 text-right text-emerald-700">{fmtNum(d.big)}</td>
                <td className="px-4 py-2 text-right font-semibold text-slate-800 whitespace-nowrap">{fmtBRL(d.valor)}</td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr className="bg-slate-50 font-bold text-slate-800 tabular-nums">
              <td className="px-4 py-2">Total</td>
              <td className="px-2 py-2 text-right">{totalDias}</td>
              <td className="px-2 py-2 text-right">{fmtNum(totalMeta)}</td>
              <td className="px-2 py-2 text-right text-emerald-700">{fmtNum(totalBig)}</td>
              <td className="px-4 py-2 text-right whitespace-nowrap">{fmtBRL(totalValor)}</td>
            </tr>
          </tfoot>
        </table>
      </div>
    </Wrapper>
  );
}
